import { isLoggedIn } from "@shapr3d/frontend-lib";
import { Outlet } from "react-router-dom";

import { navigateToAuth } from "../../utils/authUtils";

export const AuthLayout = () => {
  if (isLoggedIn()) {
    return <Outlet />;
  }

  navigateToAuth();
};
